import * as GraphQL from '~/generated/graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const AcceptAdminTermsDocument = gql`
    mutation AcceptAdminTerms($input: UnityTestLaunchIdentifierInput!) {
  acceptAdminTerms(testLaunchIdentifierInput: $input)
}
    `;

/**
 * __useAcceptAdminTermsMutation__
 *
 * To run a mutation, you first call `useAcceptAdminTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAdminTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAdminTermsMutation, { data, loading, error }] = useAcceptAdminTermsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptAdminTermsMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.AcceptAdminTermsMutation, GraphQL.AcceptAdminTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.AcceptAdminTermsMutation, GraphQL.AcceptAdminTermsMutationVariables>(AcceptAdminTermsDocument, options);
      }
export type AcceptAdminTermsMutationHookResult = ReturnType<typeof useAcceptAdminTermsMutation>;
export type AcceptAdminTermsMutationResult = Apollo.MutationResult<GraphQL.AcceptAdminTermsMutation>;
export type AcceptAdminTermsMutationOptions = Apollo.BaseMutationOptions<GraphQL.AcceptAdminTermsMutation, GraphQL.AcceptAdminTermsMutationVariables>;
export const Unity2LogoutDocument = gql`
    mutation Unity2Logout {
  unity2Logout {
    message
  }
}
    `;

/**
 * __useUnity2LogoutMutation__
 *
 * To run a mutation, you first call `useUnity2LogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnity2LogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unity2LogoutMutation, { data, loading, error }] = useUnity2LogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnity2LogoutMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.Unity2LogoutMutation, GraphQL.Unity2LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.Unity2LogoutMutation, GraphQL.Unity2LogoutMutationVariables>(Unity2LogoutDocument, options);
      }
export type Unity2LogoutMutationHookResult = ReturnType<typeof useUnity2LogoutMutation>;
export type Unity2LogoutMutationResult = Apollo.MutationResult<GraphQL.Unity2LogoutMutation>;
export type Unity2LogoutMutationOptions = Apollo.BaseMutationOptions<GraphQL.Unity2LogoutMutation, GraphQL.Unity2LogoutMutationVariables>;
export const OptInOutActRecruitMeDocument = gql`
    mutation OptInOutActRecruitMe($registrationId: String!, $optIn: Boolean!) {
  optInOutEos(registrationId: $registrationId, optIn: $optIn)
}
    `;

/**
 * __useOptInOutActRecruitMeMutation__
 *
 * To run a mutation, you first call `useOptInOutActRecruitMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptInOutActRecruitMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optInOutActRecruitMeMutation, { data, loading, error }] = useOptInOutActRecruitMeMutation({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *      optIn: // value for 'optIn'
 *   },
 * });
 */
export function useOptInOutActRecruitMeMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.OptInOutActRecruitMeMutation, GraphQL.OptInOutActRecruitMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.OptInOutActRecruitMeMutation, GraphQL.OptInOutActRecruitMeMutationVariables>(OptInOutActRecruitMeDocument, options);
      }
export type OptInOutActRecruitMeMutationHookResult = ReturnType<typeof useOptInOutActRecruitMeMutation>;
export type OptInOutActRecruitMeMutationResult = Apollo.MutationResult<GraphQL.OptInOutActRecruitMeMutation>;
export type OptInOutActRecruitMeMutationOptions = Apollo.BaseMutationOptions<GraphQL.OptInOutActRecruitMeMutation, GraphQL.OptInOutActRecruitMeMutationVariables>;
export const PostExamineeDeviceCheckResultsDocument = gql`
    mutation PostExamineeDeviceCheckResults($input: UnityUpdateRegistrationDeviceCheckResultsInput!) {
  updateRegistrationDeviceCheckResults(input: $input)
}
    `;

/**
 * __usePostExamineeDeviceCheckResultsMutation__
 *
 * To run a mutation, you first call `usePostExamineeDeviceCheckResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostExamineeDeviceCheckResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postExamineeDeviceCheckResultsMutation, { data, loading, error }] = usePostExamineeDeviceCheckResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostExamineeDeviceCheckResultsMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.PostExamineeDeviceCheckResultsMutation, GraphQL.PostExamineeDeviceCheckResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.PostExamineeDeviceCheckResultsMutation, GraphQL.PostExamineeDeviceCheckResultsMutationVariables>(PostExamineeDeviceCheckResultsDocument, options);
      }
export type PostExamineeDeviceCheckResultsMutationHookResult = ReturnType<typeof usePostExamineeDeviceCheckResultsMutation>;
export type PostExamineeDeviceCheckResultsMutationResult = Apollo.MutationResult<GraphQL.PostExamineeDeviceCheckResultsMutation>;
export type PostExamineeDeviceCheckResultsMutationOptions = Apollo.BaseMutationOptions<GraphQL.PostExamineeDeviceCheckResultsMutation, GraphQL.PostExamineeDeviceCheckResultsMutationVariables>;
export const PostLaunchStatusUpdateDocument = gql`
    mutation PostLaunchStatusUpdate($assessmentId: Int!, $registrationId: String!, $roomCode: String!) {
  postLaunchStatusUpdate(
    assessmentId: $assessmentId
    testLaunchIdentifierInput: {registrationId: $registrationId, roomCode: $roomCode}
  )
}
    `;

/**
 * __usePostLaunchStatusUpdateMutation__
 *
 * To run a mutation, you first call `usePostLaunchStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostLaunchStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postLaunchStatusUpdateMutation, { data, loading, error }] = usePostLaunchStatusUpdateMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      registrationId: // value for 'registrationId'
 *      roomCode: // value for 'roomCode'
 *   },
 * });
 */
export function usePostLaunchStatusUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.PostLaunchStatusUpdateMutation, GraphQL.PostLaunchStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.PostLaunchStatusUpdateMutation, GraphQL.PostLaunchStatusUpdateMutationVariables>(PostLaunchStatusUpdateDocument, options);
      }
export type PostLaunchStatusUpdateMutationHookResult = ReturnType<typeof usePostLaunchStatusUpdateMutation>;
export type PostLaunchStatusUpdateMutationResult = Apollo.MutationResult<GraphQL.PostLaunchStatusUpdateMutation>;
export type PostLaunchStatusUpdateMutationOptions = Apollo.BaseMutationOptions<GraphQL.PostLaunchStatusUpdateMutation, GraphQL.PostLaunchStatusUpdateMutationVariables>;
export const PostTestCenterDeviceCheckResultsDocument = gql`
    mutation PostTestCenterDeviceCheckResults($input: UnityUpdateTestCenterDeviceCheckResultsInput!) {
  updateTestCenterDeviceCheckResults(input: $input)
}
    `;

/**
 * __usePostTestCenterDeviceCheckResultsMutation__
 *
 * To run a mutation, you first call `usePostTestCenterDeviceCheckResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostTestCenterDeviceCheckResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postTestCenterDeviceCheckResultsMutation, { data, loading, error }] = usePostTestCenterDeviceCheckResultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostTestCenterDeviceCheckResultsMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.PostTestCenterDeviceCheckResultsMutation, GraphQL.PostTestCenterDeviceCheckResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.PostTestCenterDeviceCheckResultsMutation, GraphQL.PostTestCenterDeviceCheckResultsMutationVariables>(PostTestCenterDeviceCheckResultsDocument, options);
      }
export type PostTestCenterDeviceCheckResultsMutationHookResult = ReturnType<typeof usePostTestCenterDeviceCheckResultsMutation>;
export type PostTestCenterDeviceCheckResultsMutationResult = Apollo.MutationResult<GraphQL.PostTestCenterDeviceCheckResultsMutation>;
export type PostTestCenterDeviceCheckResultsMutationOptions = Apollo.BaseMutationOptions<GraphQL.PostTestCenterDeviceCheckResultsMutation, GraphQL.PostTestCenterDeviceCheckResultsMutationVariables>;
export const UnityRefreshTokenDocument = gql`
    mutation UnityRefreshToken {
  unityRefreshToken {
    accessToken
    exp
    iat
  }
}
    `;

/**
 * __useUnityRefreshTokenMutation__
 *
 * To run a mutation, you first call `useUnityRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnityRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unityRefreshTokenMutation, { data, loading, error }] = useUnityRefreshTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useUnityRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.UnityRefreshTokenMutation, GraphQL.UnityRefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.UnityRefreshTokenMutation, GraphQL.UnityRefreshTokenMutationVariables>(UnityRefreshTokenDocument, options);
      }
export type UnityRefreshTokenMutationHookResult = ReturnType<typeof useUnityRefreshTokenMutation>;
export type UnityRefreshTokenMutationResult = Apollo.MutationResult<GraphQL.UnityRefreshTokenMutation>;
export type UnityRefreshTokenMutationOptions = Apollo.BaseMutationOptions<GraphQL.UnityRefreshTokenMutation, GraphQL.UnityRefreshTokenMutationVariables>;
export const RegisterDeviceDocument = gql`
    mutation RegisterDevice($tcId: String!, $deviceId: String!) {
  registerDevice(tcId: $tcId, deviceId: $deviceId)
}
    `;

/**
 * __useRegisterDeviceMutation__
 *
 * To run a mutation, you first call `useRegisterDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerDeviceMutation, { data, loading, error }] = useRegisterDeviceMutation({
 *   variables: {
 *      tcId: // value for 'tcId'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useRegisterDeviceMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.RegisterDeviceMutation, GraphQL.RegisterDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.RegisterDeviceMutation, GraphQL.RegisterDeviceMutationVariables>(RegisterDeviceDocument, options);
      }
export type RegisterDeviceMutationHookResult = ReturnType<typeof useRegisterDeviceMutation>;
export type RegisterDeviceMutationResult = Apollo.MutationResult<GraphQL.RegisterDeviceMutation>;
export type RegisterDeviceMutationOptions = Apollo.BaseMutationOptions<GraphQL.RegisterDeviceMutation, GraphQL.RegisterDeviceMutationVariables>;
export const SigninFormDocument = gql`
    mutation SigninForm($input: Unity2UserLoginInput!) {
  unity2Login(input: $input) {
    accessToken
    exp
    iat
  }
}
    `;

/**
 * __useSigninFormMutation__
 *
 * To run a mutation, you first call `useSigninFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSigninFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signinFormMutation, { data, loading, error }] = useSigninFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSigninFormMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.SigninFormMutation, GraphQL.SigninFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.SigninFormMutation, GraphQL.SigninFormMutationVariables>(SigninFormDocument, options);
      }
export type SigninFormMutationHookResult = ReturnType<typeof useSigninFormMutation>;
export type SigninFormMutationResult = Apollo.MutationResult<GraphQL.SigninFormMutation>;
export type SigninFormMutationOptions = Apollo.BaseMutationOptions<GraphQL.SigninFormMutation, GraphQL.SigninFormMutationVariables>;
export const TcmSigninDocument = gql`
    mutation tcmSignin($input: Unity2UserLoginInput!) {
  unity2StaffLogin(input: $input) {
    accessToken
    exp
    iat
  }
}
    `;

/**
 * __useTcmSigninMutation__
 *
 * To run a mutation, you first call `useTcmSigninMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTcmSigninMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tcmSigninMutation, { data, loading, error }] = useTcmSigninMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTcmSigninMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.TcmSigninMutation, GraphQL.TcmSigninMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.TcmSigninMutation, GraphQL.TcmSigninMutationVariables>(TcmSigninDocument, options);
      }
export type TcmSigninMutationHookResult = ReturnType<typeof useTcmSigninMutation>;
export type TcmSigninMutationResult = Apollo.MutationResult<GraphQL.TcmSigninMutation>;
export type TcmSigninMutationOptions = Apollo.BaseMutationOptions<GraphQL.TcmSigninMutation, GraphQL.TcmSigninMutationVariables>;
export const UnregisterDeviceDocument = gql`
    mutation UnregisterDevice($tcId: String!, $deviceId: String!) {
  deRegisterDevice(tcId: $tcId, deviceId: $deviceId)
}
    `;

/**
 * __useUnregisterDeviceMutation__
 *
 * To run a mutation, you first call `useUnregisterDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnregisterDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unregisterDeviceMutation, { data, loading, error }] = useUnregisterDeviceMutation({
 *   variables: {
 *      tcId: // value for 'tcId'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useUnregisterDeviceMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.UnregisterDeviceMutation, GraphQL.UnregisterDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.UnregisterDeviceMutation, GraphQL.UnregisterDeviceMutationVariables>(UnregisterDeviceDocument, options);
      }
export type UnregisterDeviceMutationHookResult = ReturnType<typeof useUnregisterDeviceMutation>;
export type UnregisterDeviceMutationResult = Apollo.MutationResult<GraphQL.UnregisterDeviceMutation>;
export type UnregisterDeviceMutationOptions = Apollo.BaseMutationOptions<GraphQL.UnregisterDeviceMutation, GraphQL.UnregisterDeviceMutationVariables>;
export const VendorCallbackStatusUpdateDocument = gql`
    mutation VendorCallbackStatusUpdate($returnParameters: String!) {
  vendorCallbackStatusUpdate(returnParameters: $returnParameters) {
    assessmentLabel
    assessmentStatus
    registrationId
    roomCode
  }
}
    `;

/**
 * __useVendorCallbackStatusUpdateMutation__
 *
 * To run a mutation, you first call `useVendorCallbackStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCallbackStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCallbackStatusUpdateMutation, { data, loading, error }] = useVendorCallbackStatusUpdateMutation({
 *   variables: {
 *      returnParameters: // value for 'returnParameters'
 *   },
 * });
 */
export function useVendorCallbackStatusUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GraphQL.VendorCallbackStatusUpdateMutation, GraphQL.VendorCallbackStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphQL.VendorCallbackStatusUpdateMutation, GraphQL.VendorCallbackStatusUpdateMutationVariables>(VendorCallbackStatusUpdateDocument, options);
      }
export type VendorCallbackStatusUpdateMutationHookResult = ReturnType<typeof useVendorCallbackStatusUpdateMutation>;
export type VendorCallbackStatusUpdateMutationResult = Apollo.MutationResult<GraphQL.VendorCallbackStatusUpdateMutation>;
export type VendorCallbackStatusUpdateMutationOptions = Apollo.BaseMutationOptions<GraphQL.VendorCallbackStatusUpdateMutation, GraphQL.VendorCallbackStatusUpdateMutationVariables>;
export const DialogEnterRoomCodeDocument = gql`
    query DialogEnterRoomCode($input: UnityTestLaunchIdentifierInput!) {
  tlpGuard(testLaunchIdentifierInput: $input)
}
    `;

/**
 * __useDialogEnterRoomCodeQuery__
 *
 * To run a query within a React component, call `useDialogEnterRoomCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialogEnterRoomCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDialogEnterRoomCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDialogEnterRoomCodeQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.DialogEnterRoomCodeQuery, GraphQL.DialogEnterRoomCodeQueryVariables> & ({ variables: GraphQL.DialogEnterRoomCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.DialogEnterRoomCodeQuery, GraphQL.DialogEnterRoomCodeQueryVariables>(DialogEnterRoomCodeDocument, options);
      }
export function useDialogEnterRoomCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.DialogEnterRoomCodeQuery, GraphQL.DialogEnterRoomCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.DialogEnterRoomCodeQuery, GraphQL.DialogEnterRoomCodeQueryVariables>(DialogEnterRoomCodeDocument, options);
        }
export function useDialogEnterRoomCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.DialogEnterRoomCodeQuery, GraphQL.DialogEnterRoomCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.DialogEnterRoomCodeQuery, GraphQL.DialogEnterRoomCodeQueryVariables>(DialogEnterRoomCodeDocument, options);
        }
export type DialogEnterRoomCodeQueryHookResult = ReturnType<typeof useDialogEnterRoomCodeQuery>;
export type DialogEnterRoomCodeLazyQueryHookResult = ReturnType<typeof useDialogEnterRoomCodeLazyQuery>;
export type DialogEnterRoomCodeSuspenseQueryHookResult = ReturnType<typeof useDialogEnterRoomCodeSuspenseQuery>;
export type DialogEnterRoomCodeQueryResult = Apollo.QueryResult<GraphQL.DialogEnterRoomCodeQuery, GraphQL.DialogEnterRoomCodeQueryVariables>;
export const DialogTestCenterDetailsDocument = gql`
    query DialogTestCenterDetails($testCenterId: Int!) {
  testSite(tc_id: $testCenterId) {
    _id
    address {
      address
      address2
      address3
      address4
      city
      country
      latitude
      longitude
      postalCode
      state
    }
    site_name
  }
}
    `;

/**
 * __useDialogTestCenterDetailsQuery__
 *
 * To run a query within a React component, call `useDialogTestCenterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDialogTestCenterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDialogTestCenterDetailsQuery({
 *   variables: {
 *      testCenterId: // value for 'testCenterId'
 *   },
 * });
 */
export function useDialogTestCenterDetailsQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.DialogTestCenterDetailsQuery, GraphQL.DialogTestCenterDetailsQueryVariables> & ({ variables: GraphQL.DialogTestCenterDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.DialogTestCenterDetailsQuery, GraphQL.DialogTestCenterDetailsQueryVariables>(DialogTestCenterDetailsDocument, options);
      }
export function useDialogTestCenterDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.DialogTestCenterDetailsQuery, GraphQL.DialogTestCenterDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.DialogTestCenterDetailsQuery, GraphQL.DialogTestCenterDetailsQueryVariables>(DialogTestCenterDetailsDocument, options);
        }
export function useDialogTestCenterDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.DialogTestCenterDetailsQuery, GraphQL.DialogTestCenterDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.DialogTestCenterDetailsQuery, GraphQL.DialogTestCenterDetailsQueryVariables>(DialogTestCenterDetailsDocument, options);
        }
export type DialogTestCenterDetailsQueryHookResult = ReturnType<typeof useDialogTestCenterDetailsQuery>;
export type DialogTestCenterDetailsLazyQueryHookResult = ReturnType<typeof useDialogTestCenterDetailsLazyQuery>;
export type DialogTestCenterDetailsSuspenseQueryHookResult = ReturnType<typeof useDialogTestCenterDetailsSuspenseQuery>;
export type DialogTestCenterDetailsQueryResult = Apollo.QueryResult<GraphQL.DialogTestCenterDetailsQuery, GraphQL.DialogTestCenterDetailsQueryVariables>;
export const ExamineeDeviceCheckResultsDocument = gql`
    query ExamineeDeviceCheckResults($input: GetDeviceCheckResultsByRegistrationInput!) {
  registrationDeviceCheckResults(input: $input) {
    completeDeviceCheckResults
    device_check_result
    device_check_type
    device_id
    product_identifier
    registration_id
    requested_at
  }
}
    `;

/**
 * __useExamineeDeviceCheckResultsQuery__
 *
 * To run a query within a React component, call `useExamineeDeviceCheckResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExamineeDeviceCheckResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExamineeDeviceCheckResultsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExamineeDeviceCheckResultsQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.ExamineeDeviceCheckResultsQuery, GraphQL.ExamineeDeviceCheckResultsQueryVariables> & ({ variables: GraphQL.ExamineeDeviceCheckResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.ExamineeDeviceCheckResultsQuery, GraphQL.ExamineeDeviceCheckResultsQueryVariables>(ExamineeDeviceCheckResultsDocument, options);
      }
export function useExamineeDeviceCheckResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.ExamineeDeviceCheckResultsQuery, GraphQL.ExamineeDeviceCheckResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.ExamineeDeviceCheckResultsQuery, GraphQL.ExamineeDeviceCheckResultsQueryVariables>(ExamineeDeviceCheckResultsDocument, options);
        }
export function useExamineeDeviceCheckResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.ExamineeDeviceCheckResultsQuery, GraphQL.ExamineeDeviceCheckResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.ExamineeDeviceCheckResultsQuery, GraphQL.ExamineeDeviceCheckResultsQueryVariables>(ExamineeDeviceCheckResultsDocument, options);
        }
export type ExamineeDeviceCheckResultsQueryHookResult = ReturnType<typeof useExamineeDeviceCheckResultsQuery>;
export type ExamineeDeviceCheckResultsLazyQueryHookResult = ReturnType<typeof useExamineeDeviceCheckResultsLazyQuery>;
export type ExamineeDeviceCheckResultsSuspenseQueryHookResult = ReturnType<typeof useExamineeDeviceCheckResultsSuspenseQuery>;
export type ExamineeDeviceCheckResultsQueryResult = Apollo.QueryResult<GraphQL.ExamineeDeviceCheckResultsQuery, GraphQL.ExamineeDeviceCheckResultsQueryVariables>;
export const GetUnityConfigDocument = gql`
    query GetUnityConfig($input: UnityGetConfigInput!) {
  getUnityConfig(input: $input) {
    product {
      attributes {
        gatewayAppConfig {
          sentry {
            isEnabled
            loggedPriorityLevels
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUnityConfigQuery__
 *
 * To run a query within a React component, call `useGetUnityConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnityConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnityConfigQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUnityConfigQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.GetUnityConfigQuery, GraphQL.GetUnityConfigQueryVariables> & ({ variables: GraphQL.GetUnityConfigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.GetUnityConfigQuery, GraphQL.GetUnityConfigQueryVariables>(GetUnityConfigDocument, options);
      }
export function useGetUnityConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.GetUnityConfigQuery, GraphQL.GetUnityConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.GetUnityConfigQuery, GraphQL.GetUnityConfigQueryVariables>(GetUnityConfigDocument, options);
        }
export function useGetUnityConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.GetUnityConfigQuery, GraphQL.GetUnityConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.GetUnityConfigQuery, GraphQL.GetUnityConfigQueryVariables>(GetUnityConfigDocument, options);
        }
export type GetUnityConfigQueryHookResult = ReturnType<typeof useGetUnityConfigQuery>;
export type GetUnityConfigLazyQueryHookResult = ReturnType<typeof useGetUnityConfigLazyQuery>;
export type GetUnityConfigSuspenseQueryHookResult = ReturnType<typeof useGetUnityConfigSuspenseQuery>;
export type GetUnityConfigQueryResult = Apollo.QueryResult<GraphQL.GetUnityConfigQuery, GraphQL.GetUnityConfigQueryVariables>;
export const GuardRegistrationRoomCodeDocument = gql`
    query GuardRegistrationRoomCode($input: UnityTestLaunchIdentifierInput!) {
  tlpGuard(testLaunchIdentifierInput: $input)
}
    `;

/**
 * __useGuardRegistrationRoomCodeQuery__
 *
 * To run a query within a React component, call `useGuardRegistrationRoomCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardRegistrationRoomCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardRegistrationRoomCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuardRegistrationRoomCodeQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.GuardRegistrationRoomCodeQuery, GraphQL.GuardRegistrationRoomCodeQueryVariables> & ({ variables: GraphQL.GuardRegistrationRoomCodeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.GuardRegistrationRoomCodeQuery, GraphQL.GuardRegistrationRoomCodeQueryVariables>(GuardRegistrationRoomCodeDocument, options);
      }
export function useGuardRegistrationRoomCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.GuardRegistrationRoomCodeQuery, GraphQL.GuardRegistrationRoomCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.GuardRegistrationRoomCodeQuery, GraphQL.GuardRegistrationRoomCodeQueryVariables>(GuardRegistrationRoomCodeDocument, options);
        }
export function useGuardRegistrationRoomCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.GuardRegistrationRoomCodeQuery, GraphQL.GuardRegistrationRoomCodeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.GuardRegistrationRoomCodeQuery, GraphQL.GuardRegistrationRoomCodeQueryVariables>(GuardRegistrationRoomCodeDocument, options);
        }
export type GuardRegistrationRoomCodeQueryHookResult = ReturnType<typeof useGuardRegistrationRoomCodeQuery>;
export type GuardRegistrationRoomCodeLazyQueryHookResult = ReturnType<typeof useGuardRegistrationRoomCodeLazyQuery>;
export type GuardRegistrationRoomCodeSuspenseQueryHookResult = ReturnType<typeof useGuardRegistrationRoomCodeSuspenseQuery>;
export type GuardRegistrationRoomCodeQueryResult = Apollo.QueryResult<GraphQL.GuardRegistrationRoomCodeQuery, GraphQL.GuardRegistrationRoomCodeQueryVariables>;
export const GuardTestCenterDocument = gql`
    query GuardTestCenter($testCenterId: String!) {
  testCenter(tcid: $testCenterId) {
    _id
  }
}
    `;

/**
 * __useGuardTestCenterQuery__
 *
 * To run a query within a React component, call `useGuardTestCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuardTestCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuardTestCenterQuery({
 *   variables: {
 *      testCenterId: // value for 'testCenterId'
 *   },
 * });
 */
export function useGuardTestCenterQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.GuardTestCenterQuery, GraphQL.GuardTestCenterQueryVariables> & ({ variables: GraphQL.GuardTestCenterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.GuardTestCenterQuery, GraphQL.GuardTestCenterQueryVariables>(GuardTestCenterDocument, options);
      }
export function useGuardTestCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.GuardTestCenterQuery, GraphQL.GuardTestCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.GuardTestCenterQuery, GraphQL.GuardTestCenterQueryVariables>(GuardTestCenterDocument, options);
        }
export function useGuardTestCenterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.GuardTestCenterQuery, GraphQL.GuardTestCenterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.GuardTestCenterQuery, GraphQL.GuardTestCenterQueryVariables>(GuardTestCenterDocument, options);
        }
export type GuardTestCenterQueryHookResult = ReturnType<typeof useGuardTestCenterQuery>;
export type GuardTestCenterLazyQueryHookResult = ReturnType<typeof useGuardTestCenterLazyQuery>;
export type GuardTestCenterSuspenseQueryHookResult = ReturnType<typeof useGuardTestCenterSuspenseQuery>;
export type GuardTestCenterQueryResult = Apollo.QueryResult<GraphQL.GuardTestCenterQuery, GraphQL.GuardTestCenterQueryVariables>;
export const HydrateDeviceChecksToRunDocument = gql`
    query HydrateDeviceChecksToRun($input: UnityGetConfigInput!) {
  getUnityConfig(input: $input) {
    _id
    identifier
    product {
      attributes {
        accessibility {
          calculatorEndpoint
          os {
            MacOS {
              tools
            }
            Windows {
              tools
            }
          }
        }
        gatewayAppConfig {
          blacklistedApps {
            friendlyName
            processNameWin
            processNameMac
          }
          whiteListedUrls
          openedAppsCheckExemptions
        }
        programs
      }
      _id
      name
      identifier
      version
      uiConfig {
        testCenterId
        name
        address {
          address
          address2
          address3
          address4
          city
          state
          postalCode
          country
          latitude
          longitude
        }
        colors {
          primary
          secondary
          text
        }
      }
      deliveryEngine {
        engineType
        idleTimeout
      }
      deviceCheck {
        install {
          requiresDeviceIntegrity
          requiresDeviceLockdown
          minimumOSVersion {
            Windows
            MacOS
            ChromeOS
            Android
            iOS
          }
          minimumUnityVersion {
            Windows
            iOS
            ChromeOS
            Android
            MacOS
          }
          minimumBatteryLevel
          minScreenSize {
            Windows
            iOS
            ChromeOS
            Android
            MacOS
          }
          externalApplicationsProhibited
          externalStorageProhibited
          requiresSecureNetwork
          requiredACTEndpoint
          multipleMonitorsProhibited
        }
        preCheck {
          externalApplicationsProhibited
          requiresDeviceIntegrity
          requiresDeviceLockdown
          minimumBatteryLevel
          externalStorageProhibited
          requiresSecureNetwork
          requiredACTEndpoint
          requiredProductEndpoints
          multipleMonitorsProhibited
          minScreenSize {
            Windows
            iOS
            ChromeOS
            Android
            MacOS
          }
          minimumOSVersion {
            Windows
            MacOS
            ChromeOS
            Android
            iOS
          }
          minimumUnityVersion {
            Windows
            iOS
            ChromeOS
            Android
            MacOS
          }
        }
        JIT {
          externalApplicationsProhibited
          requiresDeviceIntegrity
          requiresDeviceLockdown
          minimumBatteryLevel
          externalStorageProhibited
          requiresSecureNetwork
          requiredACTEndpoint
          requiredProductEndpoints
          multipleMonitorsProhibited
          minScreenSize {
            Windows
            iOS
            ChromeOS
            Android
            MacOS
          }
          minimumOSVersion {
            Windows
            MacOS
            ChromeOS
            Android
            iOS
          }
          minimumUnityVersion {
            Windows
            iOS
            ChromeOS
            Android
            MacOS
          }
        }
        exam {
          touchScreen
          externalStorageProhibited
          repeatFrequency
          minimumBatteryLevel
          multipleMonitorsProhibited
        }
      }
      testCenterProviding
      displayOnDevice
    }
    version
  }
}
    `;

/**
 * __useHydrateDeviceChecksToRunQuery__
 *
 * To run a query within a React component, call `useHydrateDeviceChecksToRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useHydrateDeviceChecksToRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHydrateDeviceChecksToRunQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useHydrateDeviceChecksToRunQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.HydrateDeviceChecksToRunQuery, GraphQL.HydrateDeviceChecksToRunQueryVariables> & ({ variables: GraphQL.HydrateDeviceChecksToRunQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.HydrateDeviceChecksToRunQuery, GraphQL.HydrateDeviceChecksToRunQueryVariables>(HydrateDeviceChecksToRunDocument, options);
      }
export function useHydrateDeviceChecksToRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.HydrateDeviceChecksToRunQuery, GraphQL.HydrateDeviceChecksToRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.HydrateDeviceChecksToRunQuery, GraphQL.HydrateDeviceChecksToRunQueryVariables>(HydrateDeviceChecksToRunDocument, options);
        }
export function useHydrateDeviceChecksToRunSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.HydrateDeviceChecksToRunQuery, GraphQL.HydrateDeviceChecksToRunQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.HydrateDeviceChecksToRunQuery, GraphQL.HydrateDeviceChecksToRunQueryVariables>(HydrateDeviceChecksToRunDocument, options);
        }
export type HydrateDeviceChecksToRunQueryHookResult = ReturnType<typeof useHydrateDeviceChecksToRunQuery>;
export type HydrateDeviceChecksToRunLazyQueryHookResult = ReturnType<typeof useHydrateDeviceChecksToRunLazyQuery>;
export type HydrateDeviceChecksToRunSuspenseQueryHookResult = ReturnType<typeof useHydrateDeviceChecksToRunSuspenseQuery>;
export type HydrateDeviceChecksToRunQueryResult = Apollo.QueryResult<GraphQL.HydrateDeviceChecksToRunQuery, GraphQL.HydrateDeviceChecksToRunQueryVariables>;
export const IndexPageDocument = gql`
    query IndexPage($currentDate: String) {
  myRegistrations(currentDate: $currentDate) {
    id
    admin {
      admin_end_date
      admin_id
      admin_start_date
    }
    program {
      program_id
      program_name
    }
    registration {
      id
    }
    state
    test_center {
      id
      location_type
      schedule_datetime
      tc_id
    }
  }
}
    `;

/**
 * __useIndexPageQuery__
 *
 * To run a query within a React component, call `useIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexPageQuery({
 *   variables: {
 *      currentDate: // value for 'currentDate'
 *   },
 * });
 */
export function useIndexPageQuery(baseOptions?: Apollo.QueryHookOptions<GraphQL.IndexPageQuery, GraphQL.IndexPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.IndexPageQuery, GraphQL.IndexPageQueryVariables>(IndexPageDocument, options);
      }
export function useIndexPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.IndexPageQuery, GraphQL.IndexPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.IndexPageQuery, GraphQL.IndexPageQueryVariables>(IndexPageDocument, options);
        }
export function useIndexPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.IndexPageQuery, GraphQL.IndexPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.IndexPageQuery, GraphQL.IndexPageQueryVariables>(IndexPageDocument, options);
        }
export type IndexPageQueryHookResult = ReturnType<typeof useIndexPageQuery>;
export type IndexPageLazyQueryHookResult = ReturnType<typeof useIndexPageLazyQuery>;
export type IndexPageSuspenseQueryHookResult = ReturnType<typeof useIndexPageSuspenseQuery>;
export type IndexPageQueryResult = Apollo.QueryResult<GraphQL.IndexPageQuery, GraphQL.IndexPageQueryVariables>;
export const IsTcmLoginEnabledDocument = gql`
    query IsTcmLoginEnabled {
  isTcmLoginEnabled
}
    `;

/**
 * __useIsTcmLoginEnabledQuery__
 *
 * To run a query within a React component, call `useIsTcmLoginEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsTcmLoginEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsTcmLoginEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsTcmLoginEnabledQuery(baseOptions?: Apollo.QueryHookOptions<GraphQL.IsTcmLoginEnabledQuery, GraphQL.IsTcmLoginEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.IsTcmLoginEnabledQuery, GraphQL.IsTcmLoginEnabledQueryVariables>(IsTcmLoginEnabledDocument, options);
      }
export function useIsTcmLoginEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.IsTcmLoginEnabledQuery, GraphQL.IsTcmLoginEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.IsTcmLoginEnabledQuery, GraphQL.IsTcmLoginEnabledQueryVariables>(IsTcmLoginEnabledDocument, options);
        }
export function useIsTcmLoginEnabledSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.IsTcmLoginEnabledQuery, GraphQL.IsTcmLoginEnabledQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.IsTcmLoginEnabledQuery, GraphQL.IsTcmLoginEnabledQueryVariables>(IsTcmLoginEnabledDocument, options);
        }
export type IsTcmLoginEnabledQueryHookResult = ReturnType<typeof useIsTcmLoginEnabledQuery>;
export type IsTcmLoginEnabledLazyQueryHookResult = ReturnType<typeof useIsTcmLoginEnabledLazyQuery>;
export type IsTcmLoginEnabledSuspenseQueryHookResult = ReturnType<typeof useIsTcmLoginEnabledSuspenseQuery>;
export type IsTcmLoginEnabledQueryResult = Apollo.QueryResult<GraphQL.IsTcmLoginEnabledQuery, GraphQL.IsTcmLoginEnabledQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    photoExempt
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<GraphQL.MeQuery, GraphQL.MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.MeQuery, GraphQL.MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.MeQuery, GraphQL.MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.MeQuery, GraphQL.MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.MeQuery, GraphQL.MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.MeQuery, GraphQL.MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<GraphQL.MeQuery, GraphQL.MeQueryVariables>;
export const MeStaffDocument = gql`
    query MeStaff {
  me {
    id
  }
}
    `;

/**
 * __useMeStaffQuery__
 *
 * To run a query within a React component, call `useMeStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeStaffQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeStaffQuery(baseOptions?: Apollo.QueryHookOptions<GraphQL.MeStaffQuery, GraphQL.MeStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.MeStaffQuery, GraphQL.MeStaffQueryVariables>(MeStaffDocument, options);
      }
export function useMeStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.MeStaffQuery, GraphQL.MeStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.MeStaffQuery, GraphQL.MeStaffQueryVariables>(MeStaffDocument, options);
        }
export function useMeStaffSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.MeStaffQuery, GraphQL.MeStaffQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.MeStaffQuery, GraphQL.MeStaffQueryVariables>(MeStaffDocument, options);
        }
export type MeStaffQueryHookResult = ReturnType<typeof useMeStaffQuery>;
export type MeStaffLazyQueryHookResult = ReturnType<typeof useMeStaffLazyQuery>;
export type MeStaffSuspenseQueryHookResult = ReturnType<typeof useMeStaffSuspenseQuery>;
export type MeStaffQueryResult = Apollo.QueryResult<GraphQL.MeStaffQuery, GraphQL.MeStaffQueryVariables>;
export const MyPhotoDocument = gql`
    query MyPhoto {
  myPhotoUrl {
    durationInSec
    id
    url
  }
}
    `;

/**
 * __useMyPhotoQuery__
 *
 * To run a query within a React component, call `useMyPhotoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPhotoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPhotoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPhotoQuery(baseOptions?: Apollo.QueryHookOptions<GraphQL.MyPhotoQuery, GraphQL.MyPhotoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.MyPhotoQuery, GraphQL.MyPhotoQueryVariables>(MyPhotoDocument, options);
      }
export function useMyPhotoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.MyPhotoQuery, GraphQL.MyPhotoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.MyPhotoQuery, GraphQL.MyPhotoQueryVariables>(MyPhotoDocument, options);
        }
export function useMyPhotoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.MyPhotoQuery, GraphQL.MyPhotoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.MyPhotoQuery, GraphQL.MyPhotoQueryVariables>(MyPhotoDocument, options);
        }
export type MyPhotoQueryHookResult = ReturnType<typeof useMyPhotoQuery>;
export type MyPhotoLazyQueryHookResult = ReturnType<typeof useMyPhotoLazyQuery>;
export type MyPhotoSuspenseQueryHookResult = ReturnType<typeof useMyPhotoSuspenseQuery>;
export type MyPhotoQueryResult = Apollo.QueryResult<GraphQL.MyPhotoQuery, GraphQL.MyPhotoQueryVariables>;
export const RegistrationLayoutDocument = gql`
    query RegistrationLayout($id: String!) {
  registration(id: $id) {
    id
    program {
      program_id
      program_name
    }
  }
}
    `;

/**
 * __useRegistrationLayoutQuery__
 *
 * To run a query within a React component, call `useRegistrationLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationLayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegistrationLayoutQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RegistrationLayoutQuery, GraphQL.RegistrationLayoutQueryVariables> & ({ variables: GraphQL.RegistrationLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RegistrationLayoutQuery, GraphQL.RegistrationLayoutQueryVariables>(RegistrationLayoutDocument, options);
      }
export function useRegistrationLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RegistrationLayoutQuery, GraphQL.RegistrationLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RegistrationLayoutQuery, GraphQL.RegistrationLayoutQueryVariables>(RegistrationLayoutDocument, options);
        }
export function useRegistrationLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RegistrationLayoutQuery, GraphQL.RegistrationLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RegistrationLayoutQuery, GraphQL.RegistrationLayoutQueryVariables>(RegistrationLayoutDocument, options);
        }
export type RegistrationLayoutQueryHookResult = ReturnType<typeof useRegistrationLayoutQuery>;
export type RegistrationLayoutLazyQueryHookResult = ReturnType<typeof useRegistrationLayoutLazyQuery>;
export type RegistrationLayoutSuspenseQueryHookResult = ReturnType<typeof useRegistrationLayoutSuspenseQuery>;
export type RegistrationLayoutQueryResult = Apollo.QueryResult<GraphQL.RegistrationLayoutQuery, GraphQL.RegistrationLayoutQueryVariables>;
export const RegistrationPageDocument = gql`
    query RegistrationPage($currentDate: String, $id: String!) {
  registration(currentDate: $currentDate, id: $id) {
    id
    accomTypes
    admin {
      admin_end_date
      admin_id
      admin_start_date
      device_readiness_deadline_dt
      device_readiness_start_dt
      photo_upload_deadline
    }
    program {
      program_id
      program_name
    }
    reg_modules {
      moduleId
      name
    }
    registration {
      eos_opt_in
      id
    }
    state
    test_center {
      id
      location_type
      schedule_datetime
      tc_code
      tc_id
    }
  }
}
    `;

/**
 * __useRegistrationPageQuery__
 *
 * To run a query within a React component, call `useRegistrationPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationPageQuery({
 *   variables: {
 *      currentDate: // value for 'currentDate'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegistrationPageQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RegistrationPageQuery, GraphQL.RegistrationPageQueryVariables> & ({ variables: GraphQL.RegistrationPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RegistrationPageQuery, GraphQL.RegistrationPageQueryVariables>(RegistrationPageDocument, options);
      }
export function useRegistrationPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RegistrationPageQuery, GraphQL.RegistrationPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RegistrationPageQuery, GraphQL.RegistrationPageQueryVariables>(RegistrationPageDocument, options);
        }
export function useRegistrationPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RegistrationPageQuery, GraphQL.RegistrationPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RegistrationPageQuery, GraphQL.RegistrationPageQueryVariables>(RegistrationPageDocument, options);
        }
export type RegistrationPageQueryHookResult = ReturnType<typeof useRegistrationPageQuery>;
export type RegistrationPageLazyQueryHookResult = ReturnType<typeof useRegistrationPageLazyQuery>;
export type RegistrationPageSuspenseQueryHookResult = ReturnType<typeof useRegistrationPageSuspenseQuery>;
export type RegistrationPageQueryResult = Apollo.QueryResult<GraphQL.RegistrationPageQuery, GraphQL.RegistrationPageQueryVariables>;
export const RegistrationRoomCodeCheckPageDocument = gql`
    query RegistrationRoomCodeCheckPage($id: String!) {
  registration(id: $id) {
    id
    test_center {
      id
      tc_code
    }
  }
}
    `;

/**
 * __useRegistrationRoomCodeCheckPageQuery__
 *
 * To run a query within a React component, call `useRegistrationRoomCodeCheckPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationRoomCodeCheckPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationRoomCodeCheckPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegistrationRoomCodeCheckPageQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RegistrationRoomCodeCheckPageQuery, GraphQL.RegistrationRoomCodeCheckPageQueryVariables> & ({ variables: GraphQL.RegistrationRoomCodeCheckPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RegistrationRoomCodeCheckPageQuery, GraphQL.RegistrationRoomCodeCheckPageQueryVariables>(RegistrationRoomCodeCheckPageDocument, options);
      }
export function useRegistrationRoomCodeCheckPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RegistrationRoomCodeCheckPageQuery, GraphQL.RegistrationRoomCodeCheckPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RegistrationRoomCodeCheckPageQuery, GraphQL.RegistrationRoomCodeCheckPageQueryVariables>(RegistrationRoomCodeCheckPageDocument, options);
        }
export function useRegistrationRoomCodeCheckPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RegistrationRoomCodeCheckPageQuery, GraphQL.RegistrationRoomCodeCheckPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RegistrationRoomCodeCheckPageQuery, GraphQL.RegistrationRoomCodeCheckPageQueryVariables>(RegistrationRoomCodeCheckPageDocument, options);
        }
export type RegistrationRoomCodeCheckPageQueryHookResult = ReturnType<typeof useRegistrationRoomCodeCheckPageQuery>;
export type RegistrationRoomCodeCheckPageLazyQueryHookResult = ReturnType<typeof useRegistrationRoomCodeCheckPageLazyQuery>;
export type RegistrationRoomCodeCheckPageSuspenseQueryHookResult = ReturnType<typeof useRegistrationRoomCodeCheckPageSuspenseQuery>;
export type RegistrationRoomCodeCheckPageQueryResult = Apollo.QueryResult<GraphQL.RegistrationRoomCodeCheckPageQuery, GraphQL.RegistrationRoomCodeCheckPageQueryVariables>;
export const RegistrationRoomCodeEosPageDocument = gql`
    query RegistrationRoomCodeEOSPage($registrationId: String!) {
  registration(id: $registrationId) {
    id
    registration {
      eos_opt_in
      id
    }
    program {
      program_name
    }
    accomTypes
    state
  }
}
    `;

/**
 * __useRegistrationRoomCodeEosPageQuery__
 *
 * To run a query within a React component, call `useRegistrationRoomCodeEosPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationRoomCodeEosPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationRoomCodeEosPageQuery({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useRegistrationRoomCodeEosPageQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RegistrationRoomCodeEosPageQuery, GraphQL.RegistrationRoomCodeEosPageQueryVariables> & ({ variables: GraphQL.RegistrationRoomCodeEosPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RegistrationRoomCodeEosPageQuery, GraphQL.RegistrationRoomCodeEosPageQueryVariables>(RegistrationRoomCodeEosPageDocument, options);
      }
export function useRegistrationRoomCodeEosPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RegistrationRoomCodeEosPageQuery, GraphQL.RegistrationRoomCodeEosPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RegistrationRoomCodeEosPageQuery, GraphQL.RegistrationRoomCodeEosPageQueryVariables>(RegistrationRoomCodeEosPageDocument, options);
        }
export function useRegistrationRoomCodeEosPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RegistrationRoomCodeEosPageQuery, GraphQL.RegistrationRoomCodeEosPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RegistrationRoomCodeEosPageQuery, GraphQL.RegistrationRoomCodeEosPageQueryVariables>(RegistrationRoomCodeEosPageDocument, options);
        }
export type RegistrationRoomCodeEosPageQueryHookResult = ReturnType<typeof useRegistrationRoomCodeEosPageQuery>;
export type RegistrationRoomCodeEosPageLazyQueryHookResult = ReturnType<typeof useRegistrationRoomCodeEosPageLazyQuery>;
export type RegistrationRoomCodeEosPageSuspenseQueryHookResult = ReturnType<typeof useRegistrationRoomCodeEosPageSuspenseQuery>;
export type RegistrationRoomCodeEosPageQueryResult = Apollo.QueryResult<GraphQL.RegistrationRoomCodeEosPageQuery, GraphQL.RegistrationRoomCodeEosPageQueryVariables>;
export const RegistrationRoomCodeInfoPageDocument = gql`
    query RegistrationRoomCodeInfoPage($registrationId: String!) {
  me {
    id
    firstName
    lastName
  }
  registration(id: $registrationId) {
    id
    test_center {
      id
      tc_id
    }
  }
}
    `;

/**
 * __useRegistrationRoomCodeInfoPageQuery__
 *
 * To run a query within a React component, call `useRegistrationRoomCodeInfoPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationRoomCodeInfoPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationRoomCodeInfoPageQuery({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useRegistrationRoomCodeInfoPageQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RegistrationRoomCodeInfoPageQuery, GraphQL.RegistrationRoomCodeInfoPageQueryVariables> & ({ variables: GraphQL.RegistrationRoomCodeInfoPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RegistrationRoomCodeInfoPageQuery, GraphQL.RegistrationRoomCodeInfoPageQueryVariables>(RegistrationRoomCodeInfoPageDocument, options);
      }
export function useRegistrationRoomCodeInfoPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RegistrationRoomCodeInfoPageQuery, GraphQL.RegistrationRoomCodeInfoPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RegistrationRoomCodeInfoPageQuery, GraphQL.RegistrationRoomCodeInfoPageQueryVariables>(RegistrationRoomCodeInfoPageDocument, options);
        }
export function useRegistrationRoomCodeInfoPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RegistrationRoomCodeInfoPageQuery, GraphQL.RegistrationRoomCodeInfoPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RegistrationRoomCodeInfoPageQuery, GraphQL.RegistrationRoomCodeInfoPageQueryVariables>(RegistrationRoomCodeInfoPageDocument, options);
        }
export type RegistrationRoomCodeInfoPageQueryHookResult = ReturnType<typeof useRegistrationRoomCodeInfoPageQuery>;
export type RegistrationRoomCodeInfoPageLazyQueryHookResult = ReturnType<typeof useRegistrationRoomCodeInfoPageLazyQuery>;
export type RegistrationRoomCodeInfoPageSuspenseQueryHookResult = ReturnType<typeof useRegistrationRoomCodeInfoPageSuspenseQuery>;
export type RegistrationRoomCodeInfoPageQueryResult = Apollo.QueryResult<GraphQL.RegistrationRoomCodeInfoPageQuery, GraphQL.RegistrationRoomCodeInfoPageQueryVariables>;
export const RegistrationRoomCodeInfoPageTestCenterDocument = gql`
    query RegistrationRoomCodeInfoPageTestCenter($testCenterId: String!) {
  testCenter(tcid: $testCenterId) {
    _id
    testCenterName
  }
}
    `;

/**
 * __useRegistrationRoomCodeInfoPageTestCenterQuery__
 *
 * To run a query within a React component, call `useRegistrationRoomCodeInfoPageTestCenterQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationRoomCodeInfoPageTestCenterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationRoomCodeInfoPageTestCenterQuery({
 *   variables: {
 *      testCenterId: // value for 'testCenterId'
 *   },
 * });
 */
export function useRegistrationRoomCodeInfoPageTestCenterQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RegistrationRoomCodeInfoPageTestCenterQuery, GraphQL.RegistrationRoomCodeInfoPageTestCenterQueryVariables> & ({ variables: GraphQL.RegistrationRoomCodeInfoPageTestCenterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RegistrationRoomCodeInfoPageTestCenterQuery, GraphQL.RegistrationRoomCodeInfoPageTestCenterQueryVariables>(RegistrationRoomCodeInfoPageTestCenterDocument, options);
      }
export function useRegistrationRoomCodeInfoPageTestCenterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RegistrationRoomCodeInfoPageTestCenterQuery, GraphQL.RegistrationRoomCodeInfoPageTestCenterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RegistrationRoomCodeInfoPageTestCenterQuery, GraphQL.RegistrationRoomCodeInfoPageTestCenterQueryVariables>(RegistrationRoomCodeInfoPageTestCenterDocument, options);
        }
export function useRegistrationRoomCodeInfoPageTestCenterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RegistrationRoomCodeInfoPageTestCenterQuery, GraphQL.RegistrationRoomCodeInfoPageTestCenterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RegistrationRoomCodeInfoPageTestCenterQuery, GraphQL.RegistrationRoomCodeInfoPageTestCenterQueryVariables>(RegistrationRoomCodeInfoPageTestCenterDocument, options);
        }
export type RegistrationRoomCodeInfoPageTestCenterQueryHookResult = ReturnType<typeof useRegistrationRoomCodeInfoPageTestCenterQuery>;
export type RegistrationRoomCodeInfoPageTestCenterLazyQueryHookResult = ReturnType<typeof useRegistrationRoomCodeInfoPageTestCenterLazyQuery>;
export type RegistrationRoomCodeInfoPageTestCenterSuspenseQueryHookResult = ReturnType<typeof useRegistrationRoomCodeInfoPageTestCenterSuspenseQuery>;
export type RegistrationRoomCodeInfoPageTestCenterQueryResult = Apollo.QueryResult<GraphQL.RegistrationRoomCodeInfoPageTestCenterQuery, GraphQL.RegistrationRoomCodeInfoPageTestCenterQueryVariables>;
export const RegistrationRoomCodeInfoPageTestSiteDocument = gql`
    query RegistrationRoomCodeInfoPageTestSite($testCenterId: Int!) {
  testSite(tc_id: $testCenterId) {
    _id
    site_name
  }
}
    `;

/**
 * __useRegistrationRoomCodeInfoPageTestSiteQuery__
 *
 * To run a query within a React component, call `useRegistrationRoomCodeInfoPageTestSiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationRoomCodeInfoPageTestSiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationRoomCodeInfoPageTestSiteQuery({
 *   variables: {
 *      testCenterId: // value for 'testCenterId'
 *   },
 * });
 */
export function useRegistrationRoomCodeInfoPageTestSiteQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RegistrationRoomCodeInfoPageTestSiteQuery, GraphQL.RegistrationRoomCodeInfoPageTestSiteQueryVariables> & ({ variables: GraphQL.RegistrationRoomCodeInfoPageTestSiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RegistrationRoomCodeInfoPageTestSiteQuery, GraphQL.RegistrationRoomCodeInfoPageTestSiteQueryVariables>(RegistrationRoomCodeInfoPageTestSiteDocument, options);
      }
export function useRegistrationRoomCodeInfoPageTestSiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RegistrationRoomCodeInfoPageTestSiteQuery, GraphQL.RegistrationRoomCodeInfoPageTestSiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RegistrationRoomCodeInfoPageTestSiteQuery, GraphQL.RegistrationRoomCodeInfoPageTestSiteQueryVariables>(RegistrationRoomCodeInfoPageTestSiteDocument, options);
        }
export function useRegistrationRoomCodeInfoPageTestSiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RegistrationRoomCodeInfoPageTestSiteQuery, GraphQL.RegistrationRoomCodeInfoPageTestSiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RegistrationRoomCodeInfoPageTestSiteQuery, GraphQL.RegistrationRoomCodeInfoPageTestSiteQueryVariables>(RegistrationRoomCodeInfoPageTestSiteDocument, options);
        }
export type RegistrationRoomCodeInfoPageTestSiteQueryHookResult = ReturnType<typeof useRegistrationRoomCodeInfoPageTestSiteQuery>;
export type RegistrationRoomCodeInfoPageTestSiteLazyQueryHookResult = ReturnType<typeof useRegistrationRoomCodeInfoPageTestSiteLazyQuery>;
export type RegistrationRoomCodeInfoPageTestSiteSuspenseQueryHookResult = ReturnType<typeof useRegistrationRoomCodeInfoPageTestSiteSuspenseQuery>;
export type RegistrationRoomCodeInfoPageTestSiteQueryResult = Apollo.QueryResult<GraphQL.RegistrationRoomCodeInfoPageTestSiteQuery, GraphQL.RegistrationRoomCodeInfoPageTestSiteQueryVariables>;
export const RegistrationRoomCodeLaunchDocument = gql`
    query RegistrationRoomCodeLaunch($input: UnityTestLaunchIdentifierInput!, $registrationId: String!) {
  assessmentsInfo(testLaunchIdentifierInput: $input) {
    assessments {
      display_order_id
      id
      isSurvey
      label
      status
    }
    directions
    id
  }
  registration(id: $registrationId) {
    program {
      program_name
    }
    accomTypes
    state
  }
}
    `;

/**
 * __useRegistrationRoomCodeLaunchQuery__
 *
 * To run a query within a React component, call `useRegistrationRoomCodeLaunchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationRoomCodeLaunchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationRoomCodeLaunchQuery({
 *   variables: {
 *      input: // value for 'input'
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useRegistrationRoomCodeLaunchQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RegistrationRoomCodeLaunchQuery, GraphQL.RegistrationRoomCodeLaunchQueryVariables> & ({ variables: GraphQL.RegistrationRoomCodeLaunchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RegistrationRoomCodeLaunchQuery, GraphQL.RegistrationRoomCodeLaunchQueryVariables>(RegistrationRoomCodeLaunchDocument, options);
      }
export function useRegistrationRoomCodeLaunchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RegistrationRoomCodeLaunchQuery, GraphQL.RegistrationRoomCodeLaunchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RegistrationRoomCodeLaunchQuery, GraphQL.RegistrationRoomCodeLaunchQueryVariables>(RegistrationRoomCodeLaunchDocument, options);
        }
export function useRegistrationRoomCodeLaunchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RegistrationRoomCodeLaunchQuery, GraphQL.RegistrationRoomCodeLaunchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RegistrationRoomCodeLaunchQuery, GraphQL.RegistrationRoomCodeLaunchQueryVariables>(RegistrationRoomCodeLaunchDocument, options);
        }
export type RegistrationRoomCodeLaunchQueryHookResult = ReturnType<typeof useRegistrationRoomCodeLaunchQuery>;
export type RegistrationRoomCodeLaunchLazyQueryHookResult = ReturnType<typeof useRegistrationRoomCodeLaunchLazyQuery>;
export type RegistrationRoomCodeLaunchSuspenseQueryHookResult = ReturnType<typeof useRegistrationRoomCodeLaunchSuspenseQuery>;
export type RegistrationRoomCodeLaunchQueryResult = Apollo.QueryResult<GraphQL.RegistrationRoomCodeLaunchQuery, GraphQL.RegistrationRoomCodeLaunchQueryVariables>;
export const RegistrationRoomCodeStatementsPageDocument = gql`
    query RegistrationRoomCodeStatementsPage($input: UnityTestLaunchIdentifierInput!, $registrationId: String!) {
  myAdminTerms(testLaunchIdentifierInput: $input) {
    accepted
    content
  }
  registration(id: $registrationId) {
    program {
      program_name
    }
    accomTypes
    state
  }
}
    `;

/**
 * __useRegistrationRoomCodeStatementsPageQuery__
 *
 * To run a query within a React component, call `useRegistrationRoomCodeStatementsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationRoomCodeStatementsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationRoomCodeStatementsPageQuery({
 *   variables: {
 *      input: // value for 'input'
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useRegistrationRoomCodeStatementsPageQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RegistrationRoomCodeStatementsPageQuery, GraphQL.RegistrationRoomCodeStatementsPageQueryVariables> & ({ variables: GraphQL.RegistrationRoomCodeStatementsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RegistrationRoomCodeStatementsPageQuery, GraphQL.RegistrationRoomCodeStatementsPageQueryVariables>(RegistrationRoomCodeStatementsPageDocument, options);
      }
export function useRegistrationRoomCodeStatementsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RegistrationRoomCodeStatementsPageQuery, GraphQL.RegistrationRoomCodeStatementsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RegistrationRoomCodeStatementsPageQuery, GraphQL.RegistrationRoomCodeStatementsPageQueryVariables>(RegistrationRoomCodeStatementsPageDocument, options);
        }
export function useRegistrationRoomCodeStatementsPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RegistrationRoomCodeStatementsPageQuery, GraphQL.RegistrationRoomCodeStatementsPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RegistrationRoomCodeStatementsPageQuery, GraphQL.RegistrationRoomCodeStatementsPageQueryVariables>(RegistrationRoomCodeStatementsPageDocument, options);
        }
export type RegistrationRoomCodeStatementsPageQueryHookResult = ReturnType<typeof useRegistrationRoomCodeStatementsPageQuery>;
export type RegistrationRoomCodeStatementsPageLazyQueryHookResult = ReturnType<typeof useRegistrationRoomCodeStatementsPageLazyQuery>;
export type RegistrationRoomCodeStatementsPageSuspenseQueryHookResult = ReturnType<typeof useRegistrationRoomCodeStatementsPageSuspenseQuery>;
export type RegistrationRoomCodeStatementsPageQueryResult = Apollo.QueryResult<GraphQL.RegistrationRoomCodeStatementsPageQuery, GraphQL.RegistrationRoomCodeStatementsPageQueryVariables>;
export const RenderAssessmentTestLaunchRequestDataDocument = gql`
    query RenderAssessmentTestLaunchRequestData($assessmentId: Int!, $registrationId: String!, $roomCode: String!) {
  testLaunchRequestData(
    assessmentId: $assessmentId
    testLaunchIdentifierInput: {registrationId: $registrationId, roomCode: $roomCode}
  ) {
    body
    headers
    isSurvey
    method
    url
  }
}
    `;

/**
 * __useRenderAssessmentTestLaunchRequestDataQuery__
 *
 * To run a query within a React component, call `useRenderAssessmentTestLaunchRequestDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderAssessmentTestLaunchRequestDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderAssessmentTestLaunchRequestDataQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      registrationId: // value for 'registrationId'
 *      roomCode: // value for 'roomCode'
 *   },
 * });
 */
export function useRenderAssessmentTestLaunchRequestDataQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RenderAssessmentTestLaunchRequestDataQuery, GraphQL.RenderAssessmentTestLaunchRequestDataQueryVariables> & ({ variables: GraphQL.RenderAssessmentTestLaunchRequestDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RenderAssessmentTestLaunchRequestDataQuery, GraphQL.RenderAssessmentTestLaunchRequestDataQueryVariables>(RenderAssessmentTestLaunchRequestDataDocument, options);
      }
export function useRenderAssessmentTestLaunchRequestDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RenderAssessmentTestLaunchRequestDataQuery, GraphQL.RenderAssessmentTestLaunchRequestDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RenderAssessmentTestLaunchRequestDataQuery, GraphQL.RenderAssessmentTestLaunchRequestDataQueryVariables>(RenderAssessmentTestLaunchRequestDataDocument, options);
        }
export function useRenderAssessmentTestLaunchRequestDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RenderAssessmentTestLaunchRequestDataQuery, GraphQL.RenderAssessmentTestLaunchRequestDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RenderAssessmentTestLaunchRequestDataQuery, GraphQL.RenderAssessmentTestLaunchRequestDataQueryVariables>(RenderAssessmentTestLaunchRequestDataDocument, options);
        }
export type RenderAssessmentTestLaunchRequestDataQueryHookResult = ReturnType<typeof useRenderAssessmentTestLaunchRequestDataQuery>;
export type RenderAssessmentTestLaunchRequestDataLazyQueryHookResult = ReturnType<typeof useRenderAssessmentTestLaunchRequestDataLazyQuery>;
export type RenderAssessmentTestLaunchRequestDataSuspenseQueryHookResult = ReturnType<typeof useRenderAssessmentTestLaunchRequestDataSuspenseQuery>;
export type RenderAssessmentTestLaunchRequestDataQueryResult = Apollo.QueryResult<GraphQL.RenderAssessmentTestLaunchRequestDataQuery, GraphQL.RenderAssessmentTestLaunchRequestDataQueryVariables>;
export const RoomCodeLayoutDocument = gql`
    query RoomCodeLayout($registrationId: String!, $roomCode: String!) {
  myAdminTerms(
    testLaunchIdentifierInput: {registrationId: $registrationId, roomCode: $roomCode}
  ) {
    accepted
  }
  registration(id: $registrationId) {
    id
    registration {
      eos_opt_in
      id
    }
  }
}
    `;

/**
 * __useRoomCodeLayoutQuery__
 *
 * To run a query within a React component, call `useRoomCodeLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomCodeLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomCodeLayoutQuery({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *      roomCode: // value for 'roomCode'
 *   },
 * });
 */
export function useRoomCodeLayoutQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.RoomCodeLayoutQuery, GraphQL.RoomCodeLayoutQueryVariables> & ({ variables: GraphQL.RoomCodeLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.RoomCodeLayoutQuery, GraphQL.RoomCodeLayoutQueryVariables>(RoomCodeLayoutDocument, options);
      }
export function useRoomCodeLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.RoomCodeLayoutQuery, GraphQL.RoomCodeLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.RoomCodeLayoutQuery, GraphQL.RoomCodeLayoutQueryVariables>(RoomCodeLayoutDocument, options);
        }
export function useRoomCodeLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.RoomCodeLayoutQuery, GraphQL.RoomCodeLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.RoomCodeLayoutQuery, GraphQL.RoomCodeLayoutQueryVariables>(RoomCodeLayoutDocument, options);
        }
export type RoomCodeLayoutQueryHookResult = ReturnType<typeof useRoomCodeLayoutQuery>;
export type RoomCodeLayoutLazyQueryHookResult = ReturnType<typeof useRoomCodeLayoutLazyQuery>;
export type RoomCodeLayoutSuspenseQueryHookResult = ReturnType<typeof useRoomCodeLayoutSuspenseQuery>;
export type RoomCodeLayoutQueryResult = Apollo.QueryResult<GraphQL.RoomCodeLayoutQuery, GraphQL.RoomCodeLayoutQueryVariables>;
export const StaffPageDocument = gql`
    query StaffPage($testCenterId: String!, $deviceId: String!) {
  testCenter(tcid: $testCenterId) {
    _id
    testCenterName
  }
  verifyTestCenterDeviceMapping(tcId: $testCenterId, deviceId: $deviceId)
}
    `;

/**
 * __useStaffPageQuery__
 *
 * To run a query within a React component, call `useStaffPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffPageQuery({
 *   variables: {
 *      testCenterId: // value for 'testCenterId'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useStaffPageQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.StaffPageQuery, GraphQL.StaffPageQueryVariables> & ({ variables: GraphQL.StaffPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.StaffPageQuery, GraphQL.StaffPageQueryVariables>(StaffPageDocument, options);
      }
export function useStaffPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.StaffPageQuery, GraphQL.StaffPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.StaffPageQuery, GraphQL.StaffPageQueryVariables>(StaffPageDocument, options);
        }
export function useStaffPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.StaffPageQuery, GraphQL.StaffPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.StaffPageQuery, GraphQL.StaffPageQueryVariables>(StaffPageDocument, options);
        }
export type StaffPageQueryHookResult = ReturnType<typeof useStaffPageQuery>;
export type StaffPageLazyQueryHookResult = ReturnType<typeof useStaffPageLazyQuery>;
export type StaffPageSuspenseQueryHookResult = ReturnType<typeof useStaffPageSuspenseQuery>;
export type StaffPageQueryResult = Apollo.QueryResult<GraphQL.StaffPageQuery, GraphQL.StaffPageQueryVariables>;
export const StaffTestCenterAboutPageDocument = gql`
    query StaffTestCenterAboutPage($testCenterId: String!) {
  testCenter(tcid: $testCenterId) {
    _id
    address {
      city
      state
    }
  }
}
    `;

/**
 * __useStaffTestCenterAboutPageQuery__
 *
 * To run a query within a React component, call `useStaffTestCenterAboutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffTestCenterAboutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffTestCenterAboutPageQuery({
 *   variables: {
 *      testCenterId: // value for 'testCenterId'
 *   },
 * });
 */
export function useStaffTestCenterAboutPageQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.StaffTestCenterAboutPageQuery, GraphQL.StaffTestCenterAboutPageQueryVariables> & ({ variables: GraphQL.StaffTestCenterAboutPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.StaffTestCenterAboutPageQuery, GraphQL.StaffTestCenterAboutPageQueryVariables>(StaffTestCenterAboutPageDocument, options);
      }
export function useStaffTestCenterAboutPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.StaffTestCenterAboutPageQuery, GraphQL.StaffTestCenterAboutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.StaffTestCenterAboutPageQuery, GraphQL.StaffTestCenterAboutPageQueryVariables>(StaffTestCenterAboutPageDocument, options);
        }
export function useStaffTestCenterAboutPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.StaffTestCenterAboutPageQuery, GraphQL.StaffTestCenterAboutPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.StaffTestCenterAboutPageQuery, GraphQL.StaffTestCenterAboutPageQueryVariables>(StaffTestCenterAboutPageDocument, options);
        }
export type StaffTestCenterAboutPageQueryHookResult = ReturnType<typeof useStaffTestCenterAboutPageQuery>;
export type StaffTestCenterAboutPageLazyQueryHookResult = ReturnType<typeof useStaffTestCenterAboutPageLazyQuery>;
export type StaffTestCenterAboutPageSuspenseQueryHookResult = ReturnType<typeof useStaffTestCenterAboutPageSuspenseQuery>;
export type StaffTestCenterAboutPageQueryResult = Apollo.QueryResult<GraphQL.StaffTestCenterAboutPageQuery, GraphQL.StaffTestCenterAboutPageQueryVariables>;
export const StaffTestCenterDeviceCheckResultsDocument = gql`
    query StaffTestCenterDeviceCheckResults($input: GetDeviceCheckResultsByTestCenterInput!) {
  testCenterDeviceCheckResults(input: $input) {
    completeDeviceCheckResults
    device_check_result
    device_check_type
    device_id
    product_identifier
    requested_at
    test_center_id
  }
}
    `;

/**
 * __useStaffTestCenterDeviceCheckResultsQuery__
 *
 * To run a query within a React component, call `useStaffTestCenterDeviceCheckResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffTestCenterDeviceCheckResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffTestCenterDeviceCheckResultsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStaffTestCenterDeviceCheckResultsQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.StaffTestCenterDeviceCheckResultsQuery, GraphQL.StaffTestCenterDeviceCheckResultsQueryVariables> & ({ variables: GraphQL.StaffTestCenterDeviceCheckResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.StaffTestCenterDeviceCheckResultsQuery, GraphQL.StaffTestCenterDeviceCheckResultsQueryVariables>(StaffTestCenterDeviceCheckResultsDocument, options);
      }
export function useStaffTestCenterDeviceCheckResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.StaffTestCenterDeviceCheckResultsQuery, GraphQL.StaffTestCenterDeviceCheckResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.StaffTestCenterDeviceCheckResultsQuery, GraphQL.StaffTestCenterDeviceCheckResultsQueryVariables>(StaffTestCenterDeviceCheckResultsDocument, options);
        }
export function useStaffTestCenterDeviceCheckResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.StaffTestCenterDeviceCheckResultsQuery, GraphQL.StaffTestCenterDeviceCheckResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.StaffTestCenterDeviceCheckResultsQuery, GraphQL.StaffTestCenterDeviceCheckResultsQueryVariables>(StaffTestCenterDeviceCheckResultsDocument, options);
        }
export type StaffTestCenterDeviceCheckResultsQueryHookResult = ReturnType<typeof useStaffTestCenterDeviceCheckResultsQuery>;
export type StaffTestCenterDeviceCheckResultsLazyQueryHookResult = ReturnType<typeof useStaffTestCenterDeviceCheckResultsLazyQuery>;
export type StaffTestCenterDeviceCheckResultsSuspenseQueryHookResult = ReturnType<typeof useStaffTestCenterDeviceCheckResultsSuspenseQuery>;
export type StaffTestCenterDeviceCheckResultsQueryResult = Apollo.QueryResult<GraphQL.StaffTestCenterDeviceCheckResultsQuery, GraphQL.StaffTestCenterDeviceCheckResultsQueryVariables>;
export const StaffTestCenterLayoutDocument = gql`
    query StaffTestCenterLayout($testCenterId: String!) {
  testCenter(tcid: $testCenterId) {
    _id
    address {
      city
      state
    }
    testCenterName
  }
}
    `;

/**
 * __useStaffTestCenterLayoutQuery__
 *
 * To run a query within a React component, call `useStaffTestCenterLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffTestCenterLayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffTestCenterLayoutQuery({
 *   variables: {
 *      testCenterId: // value for 'testCenterId'
 *   },
 * });
 */
export function useStaffTestCenterLayoutQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.StaffTestCenterLayoutQuery, GraphQL.StaffTestCenterLayoutQueryVariables> & ({ variables: GraphQL.StaffTestCenterLayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.StaffTestCenterLayoutQuery, GraphQL.StaffTestCenterLayoutQueryVariables>(StaffTestCenterLayoutDocument, options);
      }
export function useStaffTestCenterLayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.StaffTestCenterLayoutQuery, GraphQL.StaffTestCenterLayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.StaffTestCenterLayoutQuery, GraphQL.StaffTestCenterLayoutQueryVariables>(StaffTestCenterLayoutDocument, options);
        }
export function useStaffTestCenterLayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.StaffTestCenterLayoutQuery, GraphQL.StaffTestCenterLayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.StaffTestCenterLayoutQuery, GraphQL.StaffTestCenterLayoutQueryVariables>(StaffTestCenterLayoutDocument, options);
        }
export type StaffTestCenterLayoutQueryHookResult = ReturnType<typeof useStaffTestCenterLayoutQuery>;
export type StaffTestCenterLayoutLazyQueryHookResult = ReturnType<typeof useStaffTestCenterLayoutLazyQuery>;
export type StaffTestCenterLayoutSuspenseQueryHookResult = ReturnType<typeof useStaffTestCenterLayoutSuspenseQuery>;
export type StaffTestCenterLayoutQueryResult = Apollo.QueryResult<GraphQL.StaffTestCenterLayoutQuery, GraphQL.StaffTestCenterLayoutQueryVariables>;
export const StaffTestCenterRegisterPageDocument = gql`
    query StaffTestCenterRegisterPage($testCenterId: String!) {
  testCenter(tcid: $testCenterId) {
    _id
    testCenterName
  }
}
    `;

/**
 * __useStaffTestCenterRegisterPageQuery__
 *
 * To run a query within a React component, call `useStaffTestCenterRegisterPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffTestCenterRegisterPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffTestCenterRegisterPageQuery({
 *   variables: {
 *      testCenterId: // value for 'testCenterId'
 *   },
 * });
 */
export function useStaffTestCenterRegisterPageQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.StaffTestCenterRegisterPageQuery, GraphQL.StaffTestCenterRegisterPageQueryVariables> & ({ variables: GraphQL.StaffTestCenterRegisterPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.StaffTestCenterRegisterPageQuery, GraphQL.StaffTestCenterRegisterPageQueryVariables>(StaffTestCenterRegisterPageDocument, options);
      }
export function useStaffTestCenterRegisterPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.StaffTestCenterRegisterPageQuery, GraphQL.StaffTestCenterRegisterPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.StaffTestCenterRegisterPageQuery, GraphQL.StaffTestCenterRegisterPageQueryVariables>(StaffTestCenterRegisterPageDocument, options);
        }
export function useStaffTestCenterRegisterPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.StaffTestCenterRegisterPageQuery, GraphQL.StaffTestCenterRegisterPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.StaffTestCenterRegisterPageQuery, GraphQL.StaffTestCenterRegisterPageQueryVariables>(StaffTestCenterRegisterPageDocument, options);
        }
export type StaffTestCenterRegisterPageQueryHookResult = ReturnType<typeof useStaffTestCenterRegisterPageQuery>;
export type StaffTestCenterRegisterPageLazyQueryHookResult = ReturnType<typeof useStaffTestCenterRegisterPageLazyQuery>;
export type StaffTestCenterRegisterPageSuspenseQueryHookResult = ReturnType<typeof useStaffTestCenterRegisterPageSuspenseQuery>;
export type StaffTestCenterRegisterPageQueryResult = Apollo.QueryResult<GraphQL.StaffTestCenterRegisterPageQuery, GraphQL.StaffTestCenterRegisterPageQueryVariables>;
export const StaffTestCentersDocument = gql`
    query StaffTestCenters {
  staffTestCenters {
    id
    name
    code
    address1
    city
    stateCode
  }
}
    `;

/**
 * __useStaffTestCentersQuery__
 *
 * To run a query within a React component, call `useStaffTestCentersQuery` and pass it any options that fit your needs.
 * When your component renders, `useStaffTestCentersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStaffTestCentersQuery({
 *   variables: {
 *   },
 * });
 */
export function useStaffTestCentersQuery(baseOptions?: Apollo.QueryHookOptions<GraphQL.StaffTestCentersQuery, GraphQL.StaffTestCentersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.StaffTestCentersQuery, GraphQL.StaffTestCentersQueryVariables>(StaffTestCentersDocument, options);
      }
export function useStaffTestCentersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.StaffTestCentersQuery, GraphQL.StaffTestCentersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.StaffTestCentersQuery, GraphQL.StaffTestCentersQueryVariables>(StaffTestCentersDocument, options);
        }
export function useStaffTestCentersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.StaffTestCentersQuery, GraphQL.StaffTestCentersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.StaffTestCentersQuery, GraphQL.StaffTestCentersQueryVariables>(StaffTestCentersDocument, options);
        }
export type StaffTestCentersQueryHookResult = ReturnType<typeof useStaffTestCentersQuery>;
export type StaffTestCentersLazyQueryHookResult = ReturnType<typeof useStaffTestCentersLazyQuery>;
export type StaffTestCentersSuspenseQueryHookResult = ReturnType<typeof useStaffTestCentersSuspenseQuery>;
export type StaffTestCentersQueryResult = Apollo.QueryResult<GraphQL.StaffTestCentersQuery, GraphQL.StaffTestCentersQueryVariables>;
export const VerifyTestCenterDeviceMappingDocument = gql`
    query VerifyTestCenterDeviceMapping($tcId: String!, $deviceId: String!) {
  verifyTestCenterDeviceMapping(tcId: $tcId, deviceId: $deviceId)
}
    `;

/**
 * __useVerifyTestCenterDeviceMappingQuery__
 *
 * To run a query within a React component, call `useVerifyTestCenterDeviceMappingQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyTestCenterDeviceMappingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyTestCenterDeviceMappingQuery({
 *   variables: {
 *      tcId: // value for 'tcId'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useVerifyTestCenterDeviceMappingQuery(baseOptions: Apollo.QueryHookOptions<GraphQL.VerifyTestCenterDeviceMappingQuery, GraphQL.VerifyTestCenterDeviceMappingQueryVariables> & ({ variables: GraphQL.VerifyTestCenterDeviceMappingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphQL.VerifyTestCenterDeviceMappingQuery, GraphQL.VerifyTestCenterDeviceMappingQueryVariables>(VerifyTestCenterDeviceMappingDocument, options);
      }
export function useVerifyTestCenterDeviceMappingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphQL.VerifyTestCenterDeviceMappingQuery, GraphQL.VerifyTestCenterDeviceMappingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphQL.VerifyTestCenterDeviceMappingQuery, GraphQL.VerifyTestCenterDeviceMappingQueryVariables>(VerifyTestCenterDeviceMappingDocument, options);
        }
export function useVerifyTestCenterDeviceMappingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphQL.VerifyTestCenterDeviceMappingQuery, GraphQL.VerifyTestCenterDeviceMappingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphQL.VerifyTestCenterDeviceMappingQuery, GraphQL.VerifyTestCenterDeviceMappingQueryVariables>(VerifyTestCenterDeviceMappingDocument, options);
        }
export type VerifyTestCenterDeviceMappingQueryHookResult = ReturnType<typeof useVerifyTestCenterDeviceMappingQuery>;
export type VerifyTestCenterDeviceMappingLazyQueryHookResult = ReturnType<typeof useVerifyTestCenterDeviceMappingLazyQuery>;
export type VerifyTestCenterDeviceMappingSuspenseQueryHookResult = ReturnType<typeof useVerifyTestCenterDeviceMappingSuspenseQuery>;
export type VerifyTestCenterDeviceMappingQueryResult = Apollo.QueryResult<GraphQL.VerifyTestCenterDeviceMappingQuery, GraphQL.VerifyTestCenterDeviceMappingQueryVariables>;